export const api_version = 1;
export const app_version = '1.16';
export const build = '2025.06.26.10.30';
export const dev_env = false;

export const aft_server = dev_env ? 'http://aft.local' : 'https://aftplatform.com';
export const server = dev_env ? 'http://homesafealerts.local' : 'https://homesafealerts.com';

export default {
    aft: {
        api_url: `${aft_server}/api/v2/`,
        server: aft_server
    },
    app_version: app_version,
    build: build,
    dev_env: dev_env,
    version: api_version,
    server: server,
    stripe: 'pk_live_51IXdy9G6RZW42dLLvtZEQ0mn1cE10AuENLp2BxDb67TDJl62GXj82NROOfgocBWrIEvLRmJg2HpkwdYKzEbik4uQ00SyfcukVP',
    url: `${server}/api/v${api_version}`
}
